import React, { lazy, useState, useRef, useEffect } from "react";
import { useDimensions } from '../../logic/Dimensions'
import { useSeo } from '../../logic/useSeo'
import { TitleComponent } from "../TitleComponent";

const TestimonialForm = lazy(() => import('../TestimonialForm'))
const TestimonialList = lazy(() => import('../TestimonialList'))
const PrayerBanner = lazy(() => import('../PrayerBanner'))

const Testimonial = () => {
  const { height, width } = useDimensions()
  useSeo()

  return (
    <>
      {/* {width < 992 ? <PrayerBanner /> : null} */}
      <TitleComponent title="Testimonial" />
      <TestimonialForm />
      <TestimonialList />
    </>
  )
}

export default Testimonial
